import { Link } from "react-router-dom";
import Intro from "../../components/intro/Intro";
import BigPicture from "../../components/pictures/BigPicture";

const Emma = () => {
  const pictures = [
    {
      title: "MR. + MRS. AINA",
      description: <p className="o64">woohoo!! best day ever!!</p>,
      src: "https://storage.googleapis.com/squidslippers-media/portrait/wedding_celebration.jpg",
      alt: "A bride and grooom holding hands as they exit the LDS temple they just got married in.",
    },
    {
      title: "THE HAPPY COUPLE",
      description: (
        <p className="o64">
          you both looked so good and so happy!! i don't think i even saw either
          of you <i>not</i> smiling the entire day.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/wedding_stare.jpg",
      alt: "A groom (Seth, left) and bride (Emma, right) looking into each other's eyes before an embrace.",
    },
    {
      title: "UNTITLED",
      description: [
        <p className="o64">no comment.</p>,
        <p className="o64">
          <i>just kidding. you're adorable and i love you.</i>
        </p>,
      ],
      src: "https://storage.googleapis.com/squidslippers-media/portrait/wedding_kiss.jpg",
      alt: "emma and seth kissing",
    },
    // {
    //   title: "BEST STATUE EVER",
    //   description: (
    //     <p className="o64">
    //       i'm not sure if "statue" is the right word here, but i do know that
    //       "best" is! that thing is awesome!
    //     </p>
    //   ),
    //   src: "https://storage.googleapis.com/squidslippers-media/lifestyle/best_day_ever.jpg",
    //   alt: "best day ever",
    // },
    {
      title: "BEST DAY EVER",
      description: [
        <p className="o64">
          oh yeah!! best day ever!! best sign ever!! best picture ever!! (thank
          you for posing for this. that was the first time anyone has actually
          posed for me, and i love this picture.)
        </p>,
      ],
      src: "https://storage.googleapis.com/squidslippers-media/portrait/best_day_ever_pose.jpg",
      alt: "best day ever!!",
    },
    {
      title: "LU-SEE-YA",
      description: (
        <p className="o64">
          a bit of a double pun here because not only is lucia peeking through
          the face hole, but also maizey was back there holding her up at too
          awkward an angle, so the display and both girls fell over forward
          immediately after this was taken. (we caught all of them.)
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/lucia_emma.jpg",
      alt: "a baby peeking its head through a cutout",
    },
    {
      title: "A GOOD GATHERING",
      description: (
        <p className="o64">
          yowza, there were so many people there!! (and good gather fed all of
          them!!) you guys are so cool!! and everything went so well!!
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/good_gather_condiments.jpg",
      alt: "Good Gather taco condiments",
    },
    {
      title: "CAKE",
      description: (
        <p className="o64">
          a tasteful and tasty cake. props to whoever was in charge of that.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/ainas_cake.jpg",
      alt: "emma's wedding cake.",
    },
    {
      title: "FLOWERS",
      description: (
        <p className="o64">
          the flowers were all so pretty. props to whoever was in charge of
          that.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/wedding_flowers.jpg",
      alt: "emma's wedding cake.",
    },
    {
      title: "FATHER, DAUGHTER",
      description: (
        <p className="o64">
          not to make this about me, but it's times like this—when i get a great
          picture that's a little too small and blurry—that i debate getting a
          real camera...
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/dad_emma.jpg",
      alt: "dad and emma dancing",
    },
    {
      title: "FATHER, DAUGHTER 2",
      description: (
        <p className="o64">
          ...your dance with dad was lovely, though! here's proof.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/dad_emma_2.jpg",
      alt: "dad and emma dancing",
    },
    {
      title: "IT TAKES TWO",
      description: (
        <p className="o64">
          (but this is <i>not</i> a tango. it is, however, my current phone
          background.)
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/emma_seth_dance.jpg",
      alt: "emma and seth dancing.",
    },
    {
      title: "FIRST DANCE",
      description: (
        <p className="o64">
          this was such a perfect moment. love, love, love, love, love.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/emma_seth_dance_2.jpg",
      alt: "emma and seth dancing.",
    },
  ];

  return (
    <div className="main">
      <Intro
        primary="BEST DAY EVER!!"
        secondary="emma and seth!! congratulations!! that was the best day ever!! you are the best!! if you want to see some of the pictures i took..."
        tertiary="you're in the right place."
      />
      <div className="column p01 g1">
        {pictures.map((picture, index) => (
          <BigPicture
            alt={picture.alt}
            description={picture.description}
            src={picture.src}
            title={picture.title}
          />
        ))}
        <h2 className="ctext">MORE PICTURES</h2>
        <p className="ctext o64" style={{ maxWidth: "48rem" }}>
          those are all of the pictures i took of the best day ever. they're
          currently featured in my photography portfolio, along with more
          pictures i've taken.
        </p>
        <Link
          className="button"
          to="/photography"
          style={{ maxWidth: "48rem" }}
        >
          CHECK IT OUT
        </Link>
      </div>
    </div>
  );
};

export default Emma;
